import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hornbill': {
    width: 509,
    height: 512,
    paths: [
      {
        d: 'M75.4 370.3C77.5 386.1 69.6 402.3 54.4 409.6 35.6 418.7 12.9 410.8 3.8 391.9-5.3 373.1 2.6 350.3 21.4 341.3 28.5 337.9 36.1 336.8 43.3 337.9-35 226.5 95.3 147.4 95.3 147.4 89.4 190.4 87.1 238.5 87.1 238.5 19.8 280 88 302.6 126.9 311.4 146.6 365 198.1 403.3 258.5 403.3 260.5 403.3 262.3 403.1 264.2 403L264.3 421.9C165.1 423.3 105.6 392.8 75.4 370.3zM183.4 42.6C184.3 35.6 183.3 28.3 180 21.4 170.9 2.6 148.2-5.3 129.3 3.8 110.5 12.9 102.5 35.6 111.6 54.4 118.6 68.9 133.7 76.9 148.8 75.7 126.3 105.6 95 165.2 96.4 265.7L118.2 265.6C118.2 264.6 118.1 263.8 118.1 262.9 118.1 203.9 154.5 153.5 205.9 132.7 214 95 236.7 18.4 279.8 88.4 279.8 88.4 327.9 90.8 371 96.7 371 96.6 293.1-31.4 183.4 42.6zM487.6 176.8C506.4 167.7 514.4 145 505.3 126.1 496.2 107.3 473.4 99.3 454.6 108.4 439.3 115.8 431.4 132.1 433.7 148.1 402 126.1 343.9 99 250.3 100.3L250.4 122.8C253.1 122.7 255.8 122.4 258.6 122.4 317.9 122.4 368.4 159.2 389 211.2 428.1 220.2 494.1 242.8 427.5 283.7 427.5 283.7 425.2 331.9 419.3 374.9 419.3 374.9 552.7 293.7 468.2 180.3 474.7 180.8 481.3 179.8 487.6 176.8zM373.1 436.2C394.5 403.8 419.5 346.6 418.2 256.6L398.7 256.7C398.8 258.8 399 260.8 399 262.9 399 323.1 360.9 374.4 307.6 394.3 298.7 433.3 276.1 501 234.8 433.8 234.8 433.8 186.7 431.5 143.6 425.6 143.6 425.6 223.5 556.9 335.5 476.6 335.8 481.3 337 486 339.2 490.5 348.2 509.4 371 517.3 389.8 508.2 408.7 499.1 416.6 476.4 407.5 457.6 400.9 444 387.2 436.2 373.1 436.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hornbill.js
// module id = QuAa
// module chunks = 144